import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83568ba2")

_pushScopeId("data-v-83568ba2")
const _hoisted_1 = { class: "caseCard" }
const _hoisted_2 = {
  key: 0,
  class: "row flex"
}
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "content ml24 mt16 pr24 word-wrap" }
const _hoisted_5 = { class: "btns" }
const _hoisted_6 = {
  key: 1,
  class: "col mr16"
}
const _hoisted_7 = { class: "content ml24 mt16 pr24 word-wrap" }
const _hoisted_8 = { class: "btns" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.layout === 'row')
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", {
            class: "img",
            style: `background-image: url(${_ctx.cardData.imgSrc})`
          }, null, 4),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", {
              class: "title ml24 mt18 pr24",
              title: _ctx.cardData.title
            }, _toDisplayString(_ctx.cardData.title), 9, ["title"]),
            _createVNode(_component_a_tooltip, {
              title: _ctx.cardData.content
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_4, _toDisplayString(_ctx.textMaxStr(_ctx.cardData.content, 80)), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "foot", { record: _ctx.cardData })
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("div", {
            class: "img",
            style: `background-image: url(${_ctx.cardData.imgSrc})`
          }, null, 4),
          _createVNode("div", {
            class: "title ml24 mt24 pr24",
            title: _ctx.cardData.title
          }, _toDisplayString(_ctx.cardData.title), 9, ["title"]),
          _createVNode(_component_a_tooltip, {
            title: _ctx.cardData.content
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.textMaxStr(_ctx.cardData.content, 100)), 1)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode("div", _hoisted_8, [
            _renderSlot(_ctx.$slots, "foot", { record: _ctx.cardData })
          ])
        ]))
  ]))
})